import { AxiosInstance } from 'axios';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import GlobalStore from './GlobalStore';
import FutureReportModel from '../Models/FutureReportModel';

export default class FuturesReportStore {
    constructor(globalStore: GlobalStore) {
        this.axios = globalStore.axios;

        makeObservable(this, {
            experiences: observable,
            initialised: observable,
            selectedExperienceIds: observable,
            selectedExperiences: computed,
            selectExperience: action,
            selectAll: action
        });
    }

    axios: AxiosInstance;

    experiences?: FutureReportModel[];

    selectedExperienceIds: number[] = [];

    initialised = false;

    get selectedExperiences() {
        return this.experiences?.filter(e => this.selectedExperienceIds.includes(e.id));
    }

    selectExperience = (id: number) => {
        if (this.selectedExperienceIds.includes(id)) {
            this.selectedExperienceIds = this.selectedExperienceIds.filter(x => x !== id);
        } else {
            this.selectedExperienceIds.push(id);
        }
    };

    selectAll = () => {
        if (this.selectedExperienceIds.length !== (this.experiences?.length ?? 0)) {
            this.selectedExperienceIds = this.experiences?.map(e => e.id) ?? [];
        } else {
            this.selectedExperienceIds = [];
        }
    };

    initialiseAsync = async () => {
        if (this.initialised) {
            return;
        }
        runInAction(() => {
            this.initialised = true;
        });
        const experience = await this.axios.get<FutureReportModel[]>('/api/futures');
        runInAction(() => {
            this.experiences = experience.data;
        });
        this.selectAll();
    };
}
